/* eslint-disable no-console */
import { Mutation, MutationCache, Query, QueryCache, QueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
    isInternalServerError,
    isUnauthorizedError,
    passAxiosErrorFromMutationCacheToSentry,
    passAxiosErrorFromQueryCacheToSentry
} from "@/3514/utils"
import { minutes } from "@/3514/utils/time.utils"
import { handle401Error } from "@/utils/handle-401-error"

function createQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            hydrate: {
                queries: {
                    gcTime: 0,
                    retry: false
                }
            },
            dehydrate: {
                shouldDehydrateMutation: (): false => false,
                shouldDehydrateQuery: (): false => false
            },
            queries: {
                gcTime: minutes(1),
                staleTime: minutes(1),
                retry: false,
                retryOnMount: false,
                refetchOnWindowFocus: false,
                refetchOnMount: false,
                refetchOnReconnect: false,
                enabled: true,
                throwOnError: (error: AxiosError): boolean => isInternalServerError(error)
            }
        },
        mutationCache: new MutationCache({
            onError: (err: AxiosError, _variables: unknown, _context: unknown, mutation: Mutation): void => {
                void passAxiosErrorFromMutationCacheToSentry(err, mutation)

                if (isUnauthorizedError(err)) handle401Error()
            }
        }),
        queryCache: new QueryCache({
            onError: (err: AxiosError, query: Query): void => {
                void passAxiosErrorFromQueryCacheToSentry(err, query)

                if (isUnauthorizedError(err)) handle401Error()
            }
        })
    })
}

export { createQueryClient }
